module.exports = __webpack_public_path__ + "img/play-icon.7b29a882.svg";